const CONTACT_INFO = Object.freeze({
  PHONE: "+40 728 325 811",
  EMAIL: "support@nightz.app",
});

export default CONTACT_INFO;
